import Chart from './ChartContainer';

export default Chart;
